import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'About XtreamGate', to: '/about' },
  { label: 'Security & Trust', to: '/security' },
  { label: 'Support', to: '/support' },
  { label: 'Blog & Guides', to: '/blog' },
  { label: 'Free Tools', to: '/tools' },
  { label: 'Report Cloned Site', to: '/report' }
];

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="space-y-8">
          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {footerLinks.map((link, index) => (
              <motion.div
                key={link.label}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
              >
                <Link
                  to={link.to}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  {link.label}
                </Link>
              </motion.div>
            ))}
          </div>

          {/* Divider */}
          <div className="flex justify-center">
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent" />
          </div>

          {/* Bottom section */}
          <div className="space-y-4 text-center">
            {/* Status */}
            <div className="flex items-center justify-center gap-2">
              <motion.div
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [1, 0.7, 1]
                }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-2 h-2 rounded-full bg-green-400"
              />
              <span className="text-sm text-green-400 font-medium">
                All XtreamCube systems operational
              </span>
            </div>

            {/* Copyright */}
            <div className="space-y-1 text-sm text-muted-foreground">
              <p>
                © 2026 XtreamGate™. All rights reserved.
              </p>
              <p className="text-xs">
                Secure · Verified · Official Xtreamcube services.              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};